import { useMutation } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { DownloadReportResponse } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useDownloadReport = () => {
  const fetchWithAuth = useFetchWithAuth()

  return useMutation<DownloadReportResponse, Error, string>({
    mutationFn: async (reportId: string) => {
      if (!reportId) {
        throw new Error('Report ID is required to download report')
      }

      const response = await fetchWithAuth(
        `${URL}/reports/${reportId}/download`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        }
      )

      return response
    },
  })
}
